<template>
  <span class="badge badge-info">{{ label }}</span>
</template>

<script>
import { i18n } from "@/i18n";
import { rncpConstante } from "@/constantes/rncp";

export default {
  name: "TrainingRncpLevelComponent",
  components: {},
  props: {
    level: {
      type: String,
      required: true,
    },
  },
  computed: {
    label() {
      switch (this.level) {
        case rncpConstante.RNCP_LEVEL_NIV3:
          return i18n.global.t("training.rncp.level.niv3");
        case rncpConstante.RNCP_LEVEL_NIV4:
          return i18n.global.t("training.rncp.level.niv4");
        case rncpConstante.RNCP_LEVEL_NIV5:
          return i18n.global.t("training.rncp.level.niv5");
        case rncpConstante.RNCP_LEVEL_NIV7:
          return i18n.global.t("training.rncp.level.niv7");
        case rncpConstante.RNCP_LEVEL_NIV8:
          return i18n.global.t("training.rncp.level.niv8");
      }
      return this.level;
    },
  },
};
</script>

<style lang="scss" scoped></style>
